<template>
  <div :class="['tableHeadTooltip', { 'imageClass': tooltipImage }, containerClass]">
    <span v-html="title"></span>
    <TooltipPlugin
      :position="position"
      :tooltipText="tooltipText"
      :tooltipWidth="tooltipWidth"
      :showArrow="showArrow"
      :tooltipImage="tooltipImage"
      :offset="offsetTooltipImage"
    >
      <template #tooltip-btn>
        <Icons name="InfoCircle" :class="[{ 'tooltip-icon': tooltipImage }]"  color="#6B6B6B" />
      </template>
      <template #tooltip-content v-if="tooltipImage">
        <img
          :src="tooltipImage"
          alt="tooltip_image"
          class="tooltip-image"
        />
      </template>
    </TooltipPlugin>
  </div>
</template>
<script>
import { TooltipPlugin, Icons } from '@n11/so-ui-components';
export default {
  name: 'TableHeadTooltip',
  components: {
    TooltipPlugin,
    Icons,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    containerClass: {
      type: String,
      required: false,
      default: "",
    },
    tooltipText: {
      type: String,
      required: false,
      default: "",
    },
    tooltipWidth: {
      type: Number,
      required: false,
      default: 345,
    },
    tooltipImage: {
      type: String,
      required: false,
      default: null,
    },
    position: {
      type: String,
      required: false,
      default: 'bottom',
    },
    showArrow: {
      type: Boolean,
      required: false,
      default: true,
    },
    offsetTooltipImage: {
      type: Array,
      required: false,
      default: () => [0, 14],
    }
  }
} 
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
.tableHeadTooltip {
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: space-between;

  &.space-between {
    justify-content: space-between;
  }

  &.imageClass{
    position: absolute;
  }
}
.tooltip-image {
  display: flex;
  width: 260px;
  height: 370px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.tooltip-icon {
  color: transparent !important;
  transition: background-color 0.3s ease;
  width: 20px;
  height: 34px;
  &:hover {
    cursor: url('~@/assets/images/cursor.svg') 16 16, auto;
  }
}

</style>